var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lazyAudio"
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "lazyAudio",
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.liveInfo.livePeerId ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.returnLiveTips))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isHost,
      expression: "isHost"
    }],
    staticClass: "ctrlL"
  }, [_vm._v(" " + _vm._s(_vm.$t('commonSetting.ctrlL')))])]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.talkBackInfo[_vm.rtilCode],
      expression: "talkBackInfo[rtilCode]"
    }]
  }, [_vm._v(_vm._s(_vm.$t('commonSetting.cannotHear')))]), _c('div', [_vm._v(_vm._s(_vm.talkBackInfo[_vm.rtilCode] ? _vm.$t('commonSetting.lazyAudioRTips') : _vm.$t('commonSetting.lazyAudioLTips')))]), _c('div', [_vm._v(" " + _vm._s(_vm.$t('commonSetting.click')) + " "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isHost,
      expression: "isHost"
    }],
    staticClass: "ctrlL"
  }, [_vm._v("[" + _vm._s(_vm.$t('commonSetting.ctrlL')) + "]")]), _vm._v(" " + _vm._s(_vm.talkBackInfo[_vm.rtilCode] ? _vm.$t('commonSetting.lazyAudioRText') : _vm.$t('commonSetting.lazyAudioLText')) + " ")])])]), _c('i', {
    staticClass: "talkback iconfont icon-lazyAudioL",
    class: {
      'icon-lazyAudioR': _vm.talkBackInfo[_vm.rtilCode],
      active: _vm.talkBackInfo[_vm.rtilCode]
    },
    on: {
      "click": _vm.setTalkback
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };